import { Trans } from '@lingui/macro'

import * as React from 'react'

import { Badge } from '~ui/components/badges/Badge'
import { Box } from '~ui/components/layout/Box'

/**
 * Rounded badge of the alert color with the uppercase `Only for 18+` translated label.
 */
export const AgeControlBadge = () => {
  return (
    <Box display={`inline-block`}>
      <Badge bgColor={`specialColors.alert`}>
        <Box textColor={`white`}>
          <Trans>Only for 18+</Trans>
        </Box>
      </Badge>
    </Box>
  )
}
